import { render, staticRenderFns } from "./CreateDefinitive.vue?vue&type=template&id=182f6b90&scoped=true&"
import script from "./CreateDefinitive.vue?vue&type=script&lang=js&"
export * from "./CreateDefinitive.vue?vue&type=script&lang=js&"
import style0 from "./CreateDefinitive.vue?vue&type=style&index=0&id=182f6b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182f6b90",
  null
  
)

export default component.exports